/**
 * Copyright © 2024 Morton Technology Consulting, LLC
 * All rights reserved.
 * 
 * This proprietary software is the exclusive property of Morton Technology Consulting, LLC.
 * Unauthorized copying, modification, or distribution is strictly prohibited.
 */

import { QueryClient } from '@tanstack/react-query';

// Create query client with safer initialization
let queryClient: QueryClient;

try {
  queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 30000,
      },
    },
  });
} catch (error) {
  console.error('Error creating QueryClient:', error);
  // Create a basic query client if initialization fails
  queryClient = new QueryClient();
}

export { queryClient };
